'use strict';

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], function () {
            return factory();
        });

    } else if (typeof exports !== 'undefined') {
        root.BBCode = factory();

    } else {
        root.BBCode = factory();
    }
}(this, function () {
    /**
     * BBCode parser
     *
     * @param {Object} codes
     * @param {Object} [options]
     */
    function BBCode(codes, options) {
        this.codes = [];

        options = options || {};

        // copy options
        for (var optionName in options) {
            if (optionName === 'events') {
                continue;
            }
            this[optionName] = options[optionName];
        }

        this.setCodes(codes);
    }

    // prototype
    BBCode.prototype = Object.create(Object.prototype, {

        /**
         * all codes in structure.
         *
         * @var {Array}
         */
        codes: {
            value: null,
            enumerable: false,
            configurable: false,
            writable: true
        }
    });

    /**
     * parse
     *
     * @param {String} text
     * @returns {String}
     */
    BBCode.prototype.parse = function (text) {
        return this.codes.reduce(function (text, code) {
            return text.replace(code.regexp, code.replacement);
        }, text);
    };

    /**
     * add bb codes
     *
     * @param {String} regex
     * @param {String} replacement
     * @returns {BBCode}
     */
    BBCode.prototype.add = function (regex, replacement) {
        this.codes.push({
            regexp: new RegExp(regex, 'igm'),
            replacement: replacement
        });

        return this;
    };

    /**
     * set bb codes
     *
     * @param {Object} codes
     * @returns {BBCode}
     */
    BBCode.prototype.setCodes = function (codes) {
        this.codes = Object.keys(codes).map(function (regex) {
            var replacement = codes[regex];

            return {
                regexp: new RegExp(regex, 'igm'),
                replacement: replacement
            };
        }, this);

        return this;
    };

    // create the Default
    BBCode.default = new BBCode({
        // '\\\\n':'<br>',
        '\\\\n\\[li\\]': '\[li\]',
        '\\\\n\\[list\\]': '\[list\]',
        '\\[/li\\]\\\\n': '\[/li\]',
        '\\[/list\\]\\\\n': '\[/list\]',
        '\\\\n\\[ul\\]': '\[ul\]',
        '\\[/ul\\]\\\\n': '\[/ul\]',
        '\\[/ol\\]\\\\n': '\[/ol\]',
        '\\\\n\\[ol\\]': '\[ol\]',
        '\\\\n':  '<br>',
        '\\[br\\]':     '<br>',

        '\\[b\\](.+?)\\[/b\\]': '<strong>$1</strong>',
        '\\[i\\](.+?)\\[/i\\]': '<em>$1</em>',
        '\\[u\\](.+?)\\[/u\\]': '<u>$1</u>',
        '\\[s\\](.+?)\\[/s\\]': '<s>$1</s>',

        '\\[h1\\](.+?)\\[/h1\\]': '<h1><a href="$1" name="$1">$1</a></h1>',
        '\\[h2\\](.+?)\\[/h2\\]': '<h2><a href="$1" name="$1">$1</a></h2>',
        '\\[h3\\](.+?)\\[/h3\\]': '<h3><a href="$1" name="$1">$1</a></h3>',
        '\\[h4\\](.+?)\\[/h4\\]': '<h4><a href="$1" name="$1">$1</a></h4>',
        '\\[h5\\](.+?)\\[/h5\\]': '<h5><a href="$1" name="$1">$1</a></h5>',
        '\\[h6\\](.+?)\\[/h6\\]': '<h6><a href="$1" name="$1">$1</a></h6>',

        '\\[p\\](.+?)\\[/p\\]': '<p>$1</p>',
        '\\[font=(.+?)\\](.+?)\\[/font\\]':'<font face="$1">$2</font>',

        '\\[color=(.+?)\\](.+?)\\[/color\\]': '<font color="$1">$2</font>',
        '\\[size=([0-9]+)\\](.+?)\\[/size\\]': '<font size="$1">$2</font>',
        '\\[center\\](.+?)\\[/center\\]': '<div align="center">$1</div>',
        '\\[youtube\\](.+?)\\[/youtube\\]': '<div style="clear: both"><iframe width="640px" height="360px" frameborder="0" src="https://www.youtube.com/embed/$1?wmode=opaque" data-youtube-id="$1" allowfullscreen=""></iframe></div> ',
        '\\[ltr\\](.+?)\\[/ltr\\]': '<div style="direction: ltr">$1</div>',
        '\\[rtl\\](.+?)\\[/rtl\\]': '<div style="direction: rtl">$1</div>',

        '\\[img\\](.+?)\\[/img\\]': '<img src="$1">',
        '\\[img=(.+?)\\]': '<img src="$1">',

        '\\[email\\](.+?)\\[/email\\]': '<a href="mailto:$1">$1</a>',
        '\\[email=(.+?)\\](.+?)\\[/email\\]': '<a href="mailto:$1">$2</a>',

        '\\[url\\](.+?)\\[/url\\]': '<a href="$1" target="_blank">$1</a>',
        '\\[url=(.+?)\\|onclick\\](.+?)\[/url\]': '<a onclick="$1" target="_blank">$2</a>',
        '\\[url=(.+?)\starget=(.+?)\\](.+?)\[/url\]': '<a href="$1" target="$2">$3</a>',
        '\\[url=(.+?)\\](.+?)\\[/url\\]': '<a href="$1" target="_blank">$2</a>',

        '\\[a=(.+?)\\](.+?)\\[/a\\]': '<a href="$1" name="$1">$2</a>',

        '\\[list\\]((.|\\s)+?)\\[/list\\]': '<ul>$1</ul>',
        '\\[ul\\](.+?)\\[/ul\\]': '<ul>$1</ul>',
        '\\[ol\\](.+?)\\[/ol\\]': '<ol>$1</ol>',
        '\\[li\\](.+?)\\[/li\\]': '<li>$1</li>',
        '\\[\\*\\]([^\\[]+)': '<li>$1</li>',


    });

    // define configuration function for default
    BBCode.setCodes = BBCode.default.setCodes.bind(BBCode.default);

    return BBCode;
}));
